import { AlertCircle, Link2 } from "lucide-react";
import { Link } from "react-router-dom";

interface Props {
  count: number;
}

export function AliasValidationCTA({ count }: Props) {
  if (count <= 0) return null;

  return (
    <div className="max-w-6xl mx-auto mt-2 mb-1 px-4">
      <div className="rounded-xl bg-chip-orange/15 ring-1 ring-chip-orange/40 px-4 py-3">
        <div className="flex flex-wrap items-center gap-2 text-sm">
          <div className="flex items-center gap-2 text-ink dark:text-ink-dark">
            <AlertCircle className="h-4 w-4 shrink-0 text-chip-orange" />
            <span className="font-medium">
              {count} alias produit{count > 1 ? "s" : ""} à valider
            </span>
          </div>
          <div className="flex-1" />
          <Link
            to="/admin/alias-produits"
            className="inline-flex items-center gap-1 rounded-full bg-ink px-3 py-1 text-xs font-semibold text-white hover:bg-ink/90"
          >
            <Link2 className="h-3 w-3" />
            Ouvrir Alias produits
          </Link>
        </div>
      </div>
    </div>
  );
}
